module.exports = __webpack_public_path__ + "img/doctor-review.338f4003.png";